import React, { useReducer, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import SettingsSectionView from '../component/SettingsSectionView'
import ConfirmableCheckbox from '../../../../../../../Components/ConfirmableCheckbox/container/ConfirmableCheckbox'
import { authorization } from '../../../../../../../Module/Auth/Auth'
import { updateUserData } from '../../../../../../../Module/graphQL'
import { SelectDashboard } from '../../../../../../../Components/Form'
import { updateRestrictedMissionType } from './gql'
import { MISSION_TYPES_OPTIONS } from './options'
import Note from '../../../../../../../Components/Note'

const ACTIONS = {
  SET_IS_TL: 'SET_IS_TL',
  MERGE_UPDATED_SETTINGS: 'MERGE_UPDATED_SETTINGS',
}

const getInitialState = ({ isTeamLeader }) => ({
  isTeamLeader,
})

const reducer = (state, action) => {
  if (action.type === ACTIONS.SET_IS_TL) {
    return {
      ...state,
      isTeamLeader: action.value,
    }
  }
  if (action.type === ACTIONS.MERGE_UPDATED_SETTINGS) {
    return {
      ...state,
      ...action.value,
    }
  }
  return state
}

const SettingsSection = ({ ambassador = {}, teamLeaderEnabled }) => {
  const [settings, settingsDispatch] = useReducer(
    reducer,
    getInitialState(ambassador),
  )
  const [loading, setLoading] = useState(false)

  const toggleIsTL = () =>
    settingsDispatch({
      type: ACTIONS.SET_IS_TL,
      value: !settings.isTeamLeader,
    })

  const onSaveUserSettings = async () => {
    setLoading(true)
    const authToken = await authorization.getAPIKey()
    const response = await updateUserData(authToken, ambassador.id, settings)
    const {
      data: {
        updateUserData: { user },
      },
    } = await response.json()
    settingsDispatch({
      type: ACTIONS.MERGE_UPDATED_SETTINGS,
      value: user.isTeamLeader,
    })
    setLoading(false)
  }

  const { restrictedMissionType, id } = ambassador

  const initValue = restrictedMissionType ? restrictedMissionType : 'ALL'

  const onChange = async (event, index, value) => {
    if (value && value !== initValue) {
      const restrictedMissionType = value === 'ALL' ? null : value

      await updateRestrictedMissionType({
        id,
        restrictedMissionType,
      })
    }
  }

  return (
    <SettingsSectionView onSave={onSaveUserSettings} loading={loading}>
      <Row>
        <Col xs={4}>
          <ConfirmableCheckbox
            disabled={!teamLeaderEnabled}
            label="Team Leader"
            value={settings.isTeamLeader}
            confirmationModal={{
              title: 'Warning',
              body: 'Are you sure?',
              onConfirm: toggleIsTL,
              showOnDisable: false,
            }}
            note={
              teamLeaderEnabled
                ? ''
                : 'Team Leader feature is disabled in city settings'
            }
          />
        </Col>
        <Col xs={3}>
          <SelectDashboard
            label="Mission Type"
            name="missionType"
            initValue={initValue}
            options={MISSION_TYPES_OPTIONS}
            onChange={onChange}
          />
          <br />
          <Note>BA will only see the missions with the selected type</Note>
        </Col>
      </Row>
    </SettingsSectionView>
  )
}

export default SettingsSection



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasador/Components/SettingsSection/container/SettingsSection.js